import loginModel from '../../../models/login.model';
import ViewBase from '../../view-base.view';
import SalesPerformanceMonthlySelloutView from './sales-performance-monthly-sellout.view';
import SalesPerformanceTargetAchievementsView from './target-achievements.view';
import SalesPerformanceVisitStoreTaskView from './visit-store-task.view';

export default function PerformanceView() {
  ViewBase.call(this);

  let performanceCategory = 1;
  const PERFORMANCE_CATEGORY = [
    { id: 1, name: 'Sales - Target vs Achievement' },
    { id: 2, name: 'Store Visit and Task' },
    { id: 3, name: [m('div', 'Monthly Sell-out'), m('div', { style: 'font-size: 0.75em' }, '(80/20 Pareto Rule)')] }
  ];

  let selectPerformanceCategory = (e) => {
    if (performanceCategory == e.target.dataset.id) return;
    performanceCategory = e.target.dataset.id;
  }

  return {
    view: (vnode) => {
      return [
        m('.row',
          m('.col-md-12',
            m("div", { "class": "cards no-leftradius" },
              m("div", {
                "class": "list-group list-group-horizontal", "id": "performance-category-tab", "role": "tablist", "style": { "max-width": "900px" },
              },
                PERFORMANCE_CATEGORY.map(pc => [
                  m("a.list-group-item.list-group-item-action.text-center", {
                    // "class": pc.id == performanceCategory ? "list-group-item list-group-item-action active" : "list-group-item list-group-item-action",
                    "class": pc.id == performanceCategory ? " active" : "",
                    "id": "performance-category-" + pc.id + "-tab", "data-bs-toggle": "list", "role": "tab", "href": "#performance-category-" + pc.id,
                    "aria-controls": "performance-category-" + pc.id, "data-id": pc.id, onclick: selectPerformanceCategory
                  },
                    pc.name
                  )
                ])
              )
              //)

            ),

            //body
            m("#nav-tabContent.tab-content",
              m("#performance-category-1.tab-pane.fade.show.active", {
                "role": "tabpanel", "aria-labelledby": "performance-category-1-tab"
              },
                m(SalesPerformanceTargetAchievementsView)
              ),
              m("#performance-category-2.tab-pane.fade", {
                "role": "tabpanel", "aria-labelledby": "performance-category-2-tab"
              },
                m(SalesPerformanceVisitStoreTaskView)
              ),
              m("#performance-category-3.tab-pane.fade", {
                "role": "tabpanel", "aria-labelledby": "performance-category-3-tab"
              },
                m(SalesPerformanceMonthlySelloutView)
              ),
            ),
          ),
        ),
        this.getBaseViews()];
    },
  };
}
